<app-breadcrumb></app-breadcrumb>
<div class="card mb-0">
    <div class="card-body">
        <dtg-manage-notice-list [listType]="DtgListType.list"></dtg-manage-notice-list>
    </div>
</div>